var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsWohlbefindenMittelFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "-1 0 32 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-wohlbefinden-mittel-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-wohlbefinden-mittel-filled"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#7F8BDB",
    fill: "#7F8BDB",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25,11 C7.38807119,11 7.5,11.1119288 7.5,11.25 C7.5,11.3880712 7.38807119,11.5 7.25,11.5 C7.11192881,11.5 7,11.3880712 7,11.25 C7,11.1119288 7.11192881,11 7.25,11",
    id: "Shape",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25,11 C22.1119288,11 22,11.1119288 22,11.25 C22,11.3880712 22.1119288,11.5 22.25,11.5 C22.3880712,11.5 22.5,11.3880712 22.5,11.25 C22.5,11.1119288 22.3880712,11 22.25,11",
    id: "Shape",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,25 C14.9311232,22.0078381 18.4938656,20.4862766 22,21.1563168",
    id: "Shape",
    stroke: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWohlbefindenMittelFilled);
export default __webpack_public_path__ + "static/media/icons-wohlbefinden-mittel-filled.3672fc3e6fce099a4e8653ea6eb84faf.svg";
export { ForwardRef as ReactComponent };